import { jsx as _jsx } from "react/jsx-runtime";
import { Prompt } from '@coveord/plasma-mantine';
import { Locales } from '../../../../strings/Locales.js';
export var DeleteSingleResourcePromptCancelButton = function DeleteSingleResourcePromptCancelButton(param) {
    var onClick = param.onClick;
    return /*#__PURE__*/ _jsx(Prompt.CancelButton, {
        onClick: onClick,
        children: Locales.format('DeleteSingleResourcePrompt.footer.button.cancel')
    });
};

//# sourceMappingURL=DeleteSingleResourcePromptCancelButton.js.map